import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { Box, Typography, styled } from '@mui/material';
import { AnsprechPersonDetails } from '@codefluegel/wowis-rest-typescript-client';

import ThemedButton from '../button/ThemedButton';
import useMedia from '../../hooks/useMedia';

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: 5,
  marginTop: 0,
  marginBottom: 0,
  paddingTop: 0,
  paddingBottom: 0,
}));

interface Props {
  emergencyContact: AnsprechPersonDetails;
  iconCenter: boolean;
}

const EmergencyContactsCard: FC<Props> = observer(props => {
  const { emergencyContact, iconCenter } = props;

  const isMobile = useMedia('md');

  return (
    <Box
      p={5}
      pt={0}
      width={isMobile ? '330px' : 400}
      height={250}
      sx={{
        background: '#F1F2F2',
        margin: 2.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        top: '-30px',
      }}
    >
      <Box
        width="210px"
        height={1}
        sx={{
          background: '#F1F2F2',
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          justifyContent: 'center',
          mb: 0,
        }}
      >
        <StyledText
          textAlign={iconCenter ? 'center' : 'left'}
          sx={{
            fontWeight: 'fontWeightBold',
            overflowWrap: 'break-word',
            paddingBottom: 1,
            fontSize: isMobile ? 13 : 12,
          }}
        >
          {`${emergencyContact.user_art}` || ''}
        </StyledText>
        {emergencyContact.firma && (
          <StyledText
            textAlign={iconCenter ? 'center' : 'left'}
            sx={{
              fontWeight: 'fontWeightBold',
              overflowWrap: 'break-word',
              paddingBottom: 1,
              fontSize: isMobile ? 13 : 12,
            }}
          >
            {`${emergencyContact.firma}` || ''}
          </StyledText>
        )}
        {emergencyContact.anmerkung && (
          <StyledText
            textAlign={iconCenter ? 'center' : 'left'}
            sx={{
              fontWeight: 'fontWeightBold',
              overflowWrap: 'break-word',
              paddingBottom: 1,
              fontSize: isMobile ? 13 : 12,
            }}
          >
            {`${emergencyContact.anmerkung}` || ''}
          </StyledText>
        )}
        <StyledText variant="body1" p={0} textAlign="center">
          {`${emergencyContact.firstname || ''} ${
            emergencyContact.surname || ''
          }`}
        </StyledText>
        {emergencyContact.kont?.dw && (
          <StyledText
            textAlign={iconCenter ? 'center' : 'left'}
            variant="body1"
            p={1}
            onClick={() => window.open(`tel:${emergencyContact.kont?.dw}`)}
            sx={{
              cursor: 'pointer',
            }}
          >
            {`T: ${emergencyContact.kont?.dw}`}
          </StyledText>
        )}
        {emergencyContact.kont?.telnr && (
          <StyledText
            textAlign={iconCenter ? 'center' : 'left'}
            variant="body1"
            p={1}
            onClick={() => window.open(`tel:${emergencyContact.kont?.telnr}`)}
            sx={{
              cursor: 'pointer',
            }}
          >
            {`T : ${emergencyContact.kont?.telnr}`}
          </StyledText>
        )}
      </Box>
      <Box minWidth={150} sx={{ mt: 2 }}>
        <ThemedButton
          label="Mail senden"
          onClick={() => window.open(`mailto:${emergencyContact.kont?.email}`)}
        />
      </Box>
    </Box>
  );
});

export default EmergencyContactsCard;
